import { useQuery } from "react-query";
import API from "../../Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";

const fetchTodaysOnlineQueueInfo = async () => {
  const { data } = await API.get("/queues/getTodaysOnlineQueueInfo");
  return data;
};

const useGetTodaysOnlineQueueInfo = (options = {}) => {
  return useQuery([QUERY_KEY.GET_TODAYS_ONLINE_QUEUE_INFO], fetchTodaysOnlineQueueInfo, options);
};

export default useGetTodaysOnlineQueueInfo;
